/**
 * A function which logs the user out
 *
 */
export default function logout() {
    window.location.reload();
  };